import {
  PullRequestInsightClient,
  ClientOutput,
} from '../../Clients/PullRequestInsightClient';
import { call, put } from 'redux-saga/effects';
import { ApiGetter } from '../../Clients/ApiGetter';
import { actions } from '../../../reducers/Dashboard/PullRequestContribution';

export const pullRequestInsightClient = new PullRequestInsightClient(
  new ApiGetter()
);

interface GetPullRequestContributionAction {
  organizationUUID: string;
}

export function* getPullRequestContribution({
  organizationUUID,
}: GetPullRequestContributionAction) {
  const { data, error }: ClientOutput = yield call(
    [pullRequestInsightClient, pullRequestInsightClient.retrieveAsync],
    organizationUUID
  );

  if (error) {
    yield put(actions.setPullRequestContributionData(undefined));
  }

  yield put(actions.setPullRequestContributionData(data));
}
